/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.account.administration.emailLanguage.controllers', [
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.account.administration.emailLanguage.services'
])

.controller('AccountAdministrationEmailLanguageController', ['$scope', '$uibModalInstance', 
'GridStateFactory',
'GridDefinitionFactory',
'EmailLanguagesService',
'selectedLanguages',
function($scope, $uibModalInstance,
  GridStateFactory,
  GridDefinitionFactory,
  EmailLanguagesService,
  selectedLanguages
  ) {

    $scope.accountAdministrationEmailLanguage = {

      model: [],

      title: 'Select Languages',
      saveText: 'Save',

      query: '',

      gridState: new GridStateFactory(),

      init: function() {
        this.gridState.setPropertyValue('sortField', 'name');
        console.log(this.gridState.getGridState());
        EmailLanguagesService.getSelectedLanguages(this.gridState.getGridState()).then(this.success.getSelectedLanguages, this.error.getSelectedLanguages);
      },

      getlanguagesList: function() {
        EmailLanguagesService.getList(this.gridState.getGridState()).then(function(res) {
          var self = $scope.accountAdministrationEmailLanguage;
          self.model = res.data.payload;
          self.setSelectedLanguages();
        });
      },

      setSelectedLanguages: function() {
        var self = $scope.accountAdministrationEmailLanguage;
        if (selectedLanguages && selectedLanguages.length) {
          self.model.map(function(item) {
            selectedLanguages.forEach(function(selected) {
              if (item.code == selected.code) {
                item.selected = true;
              }
            });
            return item;
          });
        }
      },

      checkQuery: function(item) {
        var q = '';
        if (item.name) {
          q += item.name;
        }
        if (item.code) {
          q += item.code;
        }
  
        return (q.toLowerCase().indexOf($scope.accountAdministrationEmailLanguage.query.toLowerCase()) === -1);
      },

      checkSelectedLanguages: function() {
        // EmailLanguagesService.updateSelectedLanguages($scope.accountAdministrationEmailLanguage.model)
        // .then(function(res) {
        //   $uibModalInstance.close('success');
        // }, function() {
        //   $uibModalInstance.close('success');
        // });
        $uibModalInstance.close(EmailLanguagesService.checkSelectedLanguages($scope.accountAdministrationEmailLanguage.model));
      },

      close: function() {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        $scope.accountAdministrationEmailLanguage.checkSelectedLanguages();
      },

      success: {
        init: function(response) {}, 
        getSelectedLanguages: function(res) {
            self = $scope.accountAdministrationEmailLanguage;
            selectedLanguages = res.data.payload;
            self.getlanguagesList();
        }
      },

      error: {
        init: function(response) {},
        getSelectedLanguages: function(res) {}
      }

    };

    $scope.accountAdministrationEmailLanguage.init();

}]);